import React from 'react'
import Header from '../Components/Header';
import PublicRoutes from '../routes/PublicRoutes';
import { LandingPageStyles } from '../styles/landingPage';

const PublicMainContainer = () => {
  return (
    <div className='flex flex-col bg-white'>
      <LandingPageStyles />
      <Header />
      <div className='pt-24'>
        <PublicRoutes />
      </div>
    </div>
  )
}

export default PublicMainContainer